import axios from 'axios';

export const getCommonHeaders = () => {
  const headers = {
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
    token: localStorage.getItem("token") != null ? localStorage.getItem("token") : '',
    businessLocation: localStorage.getItem("businessLocation") != null ? localStorage.getItem("businessLocation") : ''
  };

  return headers;
};

export const httpGet = async (url, config = {}) => {
  return axios
    .get(url, {
      headers: getCommonHeaders(),
      timeout: 3000000,
      ...config
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
};

export const httpDelete = async (url) => {
  return axios
    .delete(url, {
      headers: getCommonHeaders(),
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
};

export const httpPost = async (url, body) => {
  return axios
    .post(url, body, {  
      headers: getCommonHeaders(),
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
};

export const httpPut = async (url, body) => {
  return axios
    .put(url, body, {
      headers: getCommonHeaders(),
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
};

export const httpPostFormData = async (url, body) => {
  let commonHeaders = getCommonHeaders();
  delete commonHeaders.Accept;

  return axios
    .post(url, body, {  
      headers: commonHeaders,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
};

export const httpPutFormData = async (url, body) => {
  let commonHeaders = getCommonHeaders();
  delete commonHeaders.Accept;

  return axios
    .put(url, body, {  
      headers: commonHeaders,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
};

export const gptPostData = async (url, body) => {

  const businessLocationObject = localStorage.getItem("businessLocationObject") ? JSON.parse(localStorage.getItem("businessLocationObject")) : {};
  const masterLocationObject = localStorage.getItem("firstBusinessLocationObject") ? JSON.parse(localStorage.getItem("firstBusinessLocationObject")) : {};

  let gptToken = '';
  if(businessLocationObject.is_slave == 0){
    gptToken = businessLocationObject.gpt_key;
  }else{
    gptToken = masterLocationObject.gpt_key
  }

  return axios
    .post(url, body, {  
      headers:{
        'fk-profile-id': localStorage.getItem("businessLocation"),
        'gpt-token': gptToken
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
};

export const gptGetData = async (url, master_id = '') => {
  const businessLocationObject = localStorage.getItem("businessLocationObject") ? JSON.parse(localStorage.getItem("businessLocationObject")) : {};
  const masterLocationObject = localStorage.getItem("firstBusinessLocationObject") ? JSON.parse(localStorage.getItem("firstBusinessLocationObject")) : {};

  let gptToken = '';
  if(businessLocationObject.is_slave == 0){
    gptToken = businessLocationObject.gpt_key;
  }else{
    gptToken = masterLocationObject.gpt_key
  }

  return axios
    .get(url, {  
      headers:{
        'fk-profile-id': master_id ? master_id : localStorage.getItem("businessLocation"),
        'gpt-token': gptToken
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
};

export const gptDeleteData = async (url) => {
  const businessLocationObject = localStorage.getItem("businessLocationObject") ? JSON.parse(localStorage.getItem("businessLocationObject")) : {};
  const masterLocationObject = localStorage.getItem("firstBusinessLocationObject") ? JSON.parse(localStorage.getItem("firstBusinessLocationObject")) : {};

  let gptToken = '';
  if(businessLocationObject.is_slave == 0){
    gptToken = businessLocationObject.gpt_key;
  }else{
    gptToken = masterLocationObject.gpt_key
  }

  return axios
    .delete(url, {  
      headers:{
        'fk-profile-id': localStorage.getItem("businessLocation"),
        'gpt-token': gptToken
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
};

export const gptPatchData = async (url, body) => {
  const businessLocationObject = localStorage.getItem("businessLocationObject") ? JSON.parse(localStorage.getItem("businessLocationObject")) : {};
  const masterLocationObject = localStorage.getItem("firstBusinessLocationObject") ? JSON.parse(localStorage.getItem("firstBusinessLocationObject")) : {};

  let gptToken = '';
  if(businessLocationObject.is_slave == 0){
    gptToken = businessLocationObject.gpt_key;
  }else{
    gptToken = masterLocationObject.gpt_key
  }

  return axios
    .patch(url, body, {  
      headers:{
        'fk-profile-id': localStorage.getItem("businessLocation"),
        'gpt-token': gptToken
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
};